// Totes les crides van al proxy Netlify /.netlify/functions/tmb
// Això evita exposar credencials TMB al bundle del client.
const BASE = '/.netlify/functions/tmb'

async function get(subpath, params = {}) {
  const qs  = new URLSearchParams(params).toString()
  const url = `${BASE}/${subpath}${qs ? `?${qs}` : ''}`

  const res = await fetch(url)
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error(err.error ?? `Error TMB ${res.status}`)
  }
  return res.json()
}

export const tmbService = {
  /**
   * Parades de transport públic properes a unes coordenades.
   *
   * @param {number} lat
   * @param {number} lng
   * @param {number} radius - Radi de cerca en metres (defecte 500)
   * @returns {Promise<object[]>} Array de parades TMB
   */
  getNearbyStops: (lat, lng, radius = 500) =>
    get('stops', { lat, lon: lng, radi: radius }),

  /**
   * Pròximes arribades a una parada concreta.
   *
   * @param {string|number} stopId - Codi de parada TMB
   * @returns {Promise<object[]>} Array d'arribades amb horaris
   */
  getStopArrivals: (stopId) =>
    get(`stops/${stopId}/arrivals`),

  /**
   * Calcula els minuts d'espera fins a una arribada.
   * Retorna 0 si l'autobús ja ha passat.
   *
   * @param {string} arrivalTime - Hora d'arribada (ISO 8601 o "HH:MM:SS")
   * @returns {number} Minuts d'espera (≥ 0)
   */
  getWaitTime: (arrivalTime) => {
    const ara    = new Date()
    const arriba = new Date(arrivalTime)
    // Si arrivalTime és "HH:MM:SS" sense data, afegim la data d'avui
    if (isNaN(arriba.getTime())) {
      const [h, m, s] = arrivalTime.split(':').map(Number)
      arriba.setFullYear(ara.getFullYear(), ara.getMonth(), ara.getDate())
      arriba.setHours(h, m, s ?? 0, 0)
    }
    return Math.max(0, Math.floor((arriba - ara) / 60_000))
  },
}
